import Cookies from 'js-cookie';

import { UserRole, UserRoles } from '../../users/types/user-role.type';

interface UseAdminAuthResult {
  isAuthenticated: boolean;
  isAdmin: boolean;
  role: UserRole | null;
  userId: string | null;
}

const KNOWN_ROLES: string[] = Object.values(UserRoles);

const toUserRole = (value: unknown): UserRole | null =>
  typeof value === 'string' && KNOWN_ROLES.indexOf(value) !== -1 ? (value as UserRole) : null;

const toUserId = (user: { id?: unknown; _id?: unknown }): string | null => {
  const storedId = user?.id ?? user?._id;

  return typeof storedId === 'string' ? storedId : null;
};

export const useAdminAuth = (): UseAdminAuthResult => {
  const token = Cookies.get('jwt');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return {
    isAuthenticated: !!token,
    isAdmin: user?.role === 'admin' || user?.role === 'superAdmin',
    role: toUserRole(user?.role),
    userId: toUserId(user),
  };
};
